import { useEffect, useState } from "react";

export const useOnScreen = (ref: any) => {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !(ref.current instanceof Element)) {
      return;
    }

    const observer = new IntersectionObserver(([entry]) =>
      setIntersecting(entry.isIntersecting)
    );

    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, []);

  return isIntersecting;
};



// WEBPACK FOOTER //
// ./src/presentation/on-screen.ts